import { Plus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import AppDetails, { AppRecord } from '../components/AppDetails';
import './MyApps.css';
import { useEffect, useState } from 'react';
import { getAppList } from '../service/apiServices';
import { useAzureData } from '../context/AzureContext';
import PlaceHolder from '../components/PlaceHolder';
import Dialog from '../components/Dialog';
import parse from 'html-react-parser';
import { errorMessages } from '../utilities/constants';
import myapp from '../assets/icon/myappblue.svg';
import { usePromptContext } from '../context/PromptContextType';
import LoadingBox from '../components/LoadingBox';

function MyApps() {
  const { apiToken } = useAzureData();
  const [apps, setApps] = useState<AppRecord[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<any>(null);
  const { creditDataFunction, businessCategoryFunction } = usePromptContext();
  const navigate = useNavigate();
  const { tempAdmin, tempOwner } = useAzureData();

  const handleOnboardClick = () => {
    navigate('/onboarding');
  };

  const fetchApps = async () => {
    try {
      setIsLoading(true);
      const result = await getAppList(apiToken);

      const updatedData: AppRecord[] = result.onboarding_data.map((item: any) => ({
        ...item,
        environment: item.environment || '-',
        adgroupforappaccess: Array.isArray(item.adgroupforappaccess)
          ? item.adgroupforappaccess
          : item.adgroupforappaccess
            ? [item.adgroupforappaccess]
            : [],
        model_name: item.model_name || [],
        spn_appid_env_map: item.spn_appid_env_map || []
      }));

      setApps(updatedData);

      // to fix the environment issue in AppEdit Mode
      sessionStorage.setItem('AppsData', JSON.stringify(updatedData));
    } catch (error: any) {
      setErrorMessage(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchApps();
    creditDataFunction();
    businessCategoryFunction();
  }, [apiToken]);

  if (errorMessage) {
    if (errorMessage.message === 'UNAUTHORIZED') {
      return <Dialog />;
    } else if (errorMessage.message === 'NOT_FOUND') {
      return <PlaceHolder message="No applications available." />;
    } else {
      return <PlaceHolder message={parse(errorMessages.serverError)} />;
    }
  }

  if (isLoading)
    return (
      <div
        style={{ height: '100vh' }}
        className="container-fluid d-flex justify-content-center align-items-center">
        {/* <h4 className="text-center">Loading...</h4> */}
        <LoadingBox />
      </div>
    );

  return (
    <div className="myapps-container">
      {/* Header moved here */}
      <div className="app-details-header">
        <div className="header-left">
          <div className="title-row">
            <img src={myapp} alt="My Apps Icon" className="page-icon" width={24} height={24} />
            <span className="page-title">My Apps</span>
          </div>
          <p className="page-subtitle">
            Centralised control for your applications – manage app info, settings, integrations, and
            operations efficiently.
          </p>
        </div>

        <div className="header-right">
          <button className="onboard-app-btn" onClick={handleOnboardClick}>
            <Plus size={16} strokeWidth={2} />
            <span className="btn-text">Onboard App</span>
          </button>
        </div>
      </div>

      {apps.length > 0 ? (
        <AppDetails appList={apps} refetchApps={fetchApps} />
      ) : (
        <PlaceHolder message="No applications found." />
      )}
    </div>
  );
}

export default MyApps;
